@if (state$ | async; as state) {
  <div>
    <h1 class="c-h1">{{ 'ALLOWANCES.DETAIL.title' | translate }}</h1>
    <p class="u-margin-bottom-l"><a href="javascript:void(0);" class="c-back-link" (click)="onGoBackToOverview()"><i class="fa fa-arrow-left"></i> {{ 'ALLOWANCES.DETAIL.back_to_overview' | translate }}</a></p>
    @if (state.loading) {
      <myabvv-loader [message]="'GENERAL.busy_loading' | translate"></myabvv-loader>
    }
    @if (!state.loading && state.data) {
      @for (paymentMoment of state.data; track paymentMoment; let paymentNumber = $index) {
        <div>
          <div class="c-box c-box--payment-header">
            <div class="l-grid">
              <div class="l-grid__unit l-grid__unit--4of12@medium">
                <myabvv-key-value [key]="'ALLOWANCES.DETAIL.date_of_payment' | translate"
                  [value]="paymentMoment?.dateOfPayment | date:'dd/MM/yyyy'"
                [alt]="'-'"></myabvv-key-value>
              </div>
              <div class="l-grid__unit l-grid__unit--4of12@medium">
                <myabvv-key-value [key]="'ALLOWANCES.DETAIL.month_of_unemployment' | translate"
                  [value]="paymentMoment?.unemploymentMonth | date:'MM/yyyy'"
                [alt]="'-'"></myabvv-key-value>
              </div>
              <div class="l-grid__unit l-grid__unit--4of12@medium">
                <myabvv-key-value [key]="'ALLOWANCES.DETAIL.payment' | translate"
                  [value]="paymentNumber+1 + ' / ' + state.data.length"
                [alt]="'-'"></myabvv-key-value>
              </div>
            </div>
          </div>
          @for (documentSummaryItem of paymentMoment?.summary; track documentSummaryItem) {
            <myabvv-allowances-detail-summary [summaryItem]="documentSummaryItem"></myabvv-allowances-detail-summary>
          }
          @for (documentSummaryItem of paymentMoment?.summary; track documentSummaryItem) {
            <myabvv-allowances-detail-calculation [summaryItem]="documentSummaryItem"></myabvv-allowances-detail-calculation>
          }
        </div>
      }
    }
  </div>
}
